<template>
  <nav class="navbar navbar-expand-lg navbar-dark background mb-5">
    <router-link to="/"
      ><img src="../assets/logo.png" alt="Onyxia Logo" srcset=""
    /></router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link to="/" tag="li" class="nav-link">Home</router-link>
        </li>
        <li class="nav-item">
          <a href="https://onyxia-rsps.com/donate/" tag="li" class="nav-link">Store</a>
        </li>
        <li class="nav-item">
          <a href="https://onyxia-rsps.com/vote/" tag="li" class="nav-link">Vote</a>
        </li>
        <li class="nav-item">
          <a href="https://onyxia-rsps.com/hiscores/" tag="li" class="nav-link"
            >Hiscores</a
          >
        </li>
        <li class="nav-item">
          <router-link to="/discord/" tag="li" class="nav-link"
            >Discord</router-link
          >
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
* {
  font-size: 30px;
}
.background {
  background-color: rgba(0, 0, 0, 0.842);
}
nav li:hover {
  cursor: pointer;
}
</style>
